import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["display"]
  static values = { 
    min: { type: Number, default: 0 },
    max: { type: Number, default: Infinity },
    initial: { type: Number, default: 0 }
  }
  
  connect() {
    this.count = this.initialValue
    this.updateDisplay()
    this.dispatchChange()
  }
  
  increase() {
    if (this.count < this.maxValue) {
      this.count++
      this.updateDisplay()
      this.dispatchChange()
    }
  }
  
  decrease() {
    if (this.count > this.minValue) {
      this.count--
      this.updateDisplay()
      this.dispatchChange()
    }
  }
  
  updateDisplay() {
    this.displayTarget.textContent = this.count
  }
  
  dispatchChange() {
    // Dispatch custom event that matches what pets-display is listening for
    const event = new CustomEvent("counter:change", {
      bubbles: true,
      detail: { 
        count: this.count,
        element: this.element 
      }
    })
    this.element.dispatchEvent(event)
  }
}
